// Enums

export enum ModelType {
	AVAILABLE = 'available',
	SELECTED = 'selected',
	TEMPORARY = 'temporary',
}

export enum EntityStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

// Types

// Chart
export interface TotalProgressChart {
	label: string;
	total: number;
	color: string;
}
